/**
 * app.tsx — `<RouterProvider>` (Workspace-Structure §4)
 *
 * 🔄 **Open Decision #3 เคาะแล้ว 2026-08-04: React Router v8** → `ADR-006`
 *    ของเดิมในไฟล์นี้เป็น path matching เขียนมือ + `popstate`/custom event ซึ่งเป็น
 *    placeholder ที่ประกาศตัวเองไว้ว่าจะถูกแทนวันนี้ — ตอนนี้ถูกแทนแล้ว
 *
 * ตารางเส้นทางอยู่ `routes/index.tsx` · ไฟล์นี้เหลือหน้าที่เดียวคือ mount
 */
import { RouterProvider } from 'react-router';
import type { createAppRouter } from './composition/index.js';

export function App({ router }: { router: ReturnType<typeof createAppRouter> }) {
  return <RouterProvider router={router} />;
}
